import { useState, useEffect } from 'react'
import SelectWithFilter from './SelectWithFilter'
import { useFormikContext } from 'formik'

const FormikSelectWithFilter = ({ name, onChange: _onChange = false, ...props }) => {
    const { values, setFieldValue, errors, submitCount } = useFormikContext()
    const [internalTouched, setInternalTouched] = useState(false)

    props.name = name
    props.value = values[name]

    props.onChange = e => {
        setInternalTouched(true)
        props.debug && console.log('props.onChange', { e })
        setFieldValue(name, e.target.value || '' )

        _onChange && _onChange(e)
    }

    useEffect(() => {
        if (submitCount > 0) {
            setInternalTouched(true)
        }
    }, [submitCount])

    return <SelectWithFilter {...props} error={internalTouched ? errors[name] : null} />
}

export default FormikSelectWithFilter
